import React from "react";
import DealStage from "@/model/interface/DealStage";
import Deal from "@/model/interface/Deal";
import { DealKanbanCard } from "@/components/pages/deals/DealKanbanCard";
import { useMoveDealStage } from "@/hooks/useMoveDealStage";

interface DealKanbanColumnProps {
  stage: DealStage;
  deals: Deal[];
}

export function DealKanbanColumn({ stage, deals }: DealKanbanColumnProps) {
  const { moveDealStage } = useMoveDealStage();

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.currentTarget.classList.add("bg-muted/50");
  };

  const handleDragLeave = (e: React.DragEvent) => {
    e.currentTarget.classList.remove("bg-muted/50");
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.currentTarget.classList.remove("bg-muted/50");
    const dealId = e.dataTransfer.getData("dealId");
    if (dealId) {
      void moveDealStage({ id: dealId }, stage.id);
    }
  };

  return (
    <div
      className="shrink-0 w-72 flex flex-col rounded-lg border bg-card transition-colors"
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <div className="flex items-center gap-2 p-3 border-b">
        <div className="w-3 h-3 rounded-full" style={{ backgroundColor: stage.color }} />
        <span className="font-medium text-sm flex-1">{stage.name}</span>
        <span className="text-xs text-muted-foreground bg-muted px-1.5 py-0.5 rounded">{deals.length}</span>
      </div>
      <div className="flex-1 overflow-y-auto p-2 space-y-2">
        {deals.map((deal) => (
          <DealKanbanCard key={deal.id} deal={deal} />
        ))}
        {deals.length === 0 && <div className="text-center text-xs text-muted-foreground py-8">No deals</div>}
      </div>
    </div>
  );
}
